<template>
  <block ref="breceipt" :nobody="true">
    <date-range title="Phiếu nhập" v-model="daterange" class="mx-1"></date-range>
    <div style="padding: 5px;" class="d-flex">
      <input type="text" v-model="listQuery.search" class="form-control" />
      <button @click="fetchData()" class="btn btn-primary ml-2" style="width: 100px;">Tìm</button>
    </div>
    <b-button @click="printReceiptMuti()" variant="primary" class="mt-2" size="sm" :disabled="countChecked == 0">
      <i class="fa fa-print" aria-hidden="true"></i>
      In lại phiếu
    </b-button>
    <hr class="my-1" />
    <soft-table
      @rowSelected="tbSetRowSelected"
      @rowClicked="tbRowClicked"
      class="table align-items-center table-flush"
      tbody-classes="list"
      :pending="false"
      :dataTable="tableData"
      :fields="fields"
      :showAll="true"
      :minHeight="$hControl"
      :contextMenus="[
        {
          key: 'verify',
          icon: 'fa-users-cog',
          label: 'Item menu context'
        }
      ]"
      @contextMenuItemClick="tbHandleContextMenuItemClick"
      ref="soft-table"
    >
      <template v-slot:cell(code)="row">
        <b-button @click="row.toggleDetails" variant="link">
          {{ row.value }}
        </b-button>
      </template>
      <template v-slot:row-details="row">
        <div class="py-2" style="background:#fff">
          <b-row align-h="center" class="mx-0 mb-2">
            <!-- <b-button
              v-if="!row.item.userVerify"
              @click="verifyReceipt(row.item)"
              variant="success"
              class="mt-2"
              size="sm"
            >
              <i class="fa fa-check" aria-hidden="true"></i>
              Đã nhập hàng
            </b-button> -->
            <b-button @click="printReceipt(row.item)" variant="primary" class="mt-2" size="sm">
              <i class="fa fa-print" aria-hidden="true"></i>
              In lại phiếu
            </b-button>
          </b-row>
          <base-table :data="row.item.ReceiptBillDetails">
            <template slot="columns">
              <th>STT</th>
              <th>Mã lệnh chế tạo</th>
              <th>Mã sản phẩm</th>
              <th>Tên sản phẩm</th>
              <th>Quy cách</th>
              <th>Màu sắc</th>
              <th>Số lượng</th>
              <th>Số lượng đã nhập</th>
            </template>

            <template slot-scope="{ row, index }">
              <tr :key="index">
                <td class="bg-info text-light col-fix ">
                  {{ index + 1 }}
                </td>
                <td>{{ row.manufacture.code }}</td>
                <td class="text-center">{{ row.manufacture.product.code }}</td>
                <td class="text-center">
                  {{ row.manufacture.product.name }}
                  <!-- <span v-if="row.manufacture.productCustom != ''"><br />{{ row.manufacture.productCustom }}</span> -->
                  <span v-if="row.manufacture.reason"><br />{{ row.manufacture.reason.name }}</span>
                </td>
                <td class="text-center">{{ row.manufacture.productSpecify.name }} mm</td>
                <td class="text-center">{{ row.manufacture.color.label }}</td>
                <td class="text-center">{{ $formatNumber(row.quantity) }} {{ row.unit }}</td>
                <td class="text-center">{{ $formatNumber(row.quantityVerify) }} {{ row.unit }}</td>
              </tr>
              <tr v-if="row.temDetail && row.temDetail.length > 0">
                <td colspan="8">
                  <h5 class="text-center my-2">TEM ĐÃ NHẬP KHO</h5>
                  <base-table :data="row.temDetail" class="mt-2 mb-2">
                    <template slot="columns">
                      <th>STT</th>
                      <th>Mã Tem</th>
                      <th>Số lượng</th>
                      <th>Thời gian in</th>
                    </template>

                    <template slot-scope="{ item, index }">
                      <tr :key="index">
                        <td class="bg-info text-light col-fix ">
                          {{ index + 1 }}
                        </td>
                        <td>{{ item.code }}</td>
                        <td class="text-center">{{ item.quantity }} {{ row.unit }}</td>
                        <td class="text-center">
                          {{ $dateTime(item.lastDatePrint) }}
                        </td>
                      </tr>
                    </template>
                  </base-table>
                </td>
              </tr>
            </template>
          </base-table>
        </div>
      </template>
      <template v-slot:cell(customer)="{ value }">
        <strong>{{ value.code }}</strong> <br />
        <span>{{ value.name }}</span>
      </template>
      <template v-slot:cell(userCreate)="{ value }">
        <span v-if="value.id" class="badge badge-primary">{{ value.username }}</span>
      </template>
      <template v-slot:cell(userVerify)="{ value }">
        <span v-if="value.id" class="badge badge-success">{{ value.username }}</span>
        <span v-else class="badge badge-danger">
          Chưa được duyệt
        </span>
      </template>
      <template v-slot:cell(userManage)="{ value }">
        <span v-if="value.id" class="badge badge-info">{{ value.username }}</span>
        <span v-else class="badge badge-danger">
          Chưa có người hỗ trợ
        </span>
      </template>
      <template>
        <pagination
          class="mt-2 mb-2 mr-2"
          slot="footer"
          :total="listQuery.total"
          :perPage="listQuery.limit"
          @change="pagChange"
        />
      </template>
    </soft-table>
    <preview ref="preview"></preview>
  </block>
</template>
<script>
import { receiptService } from '@/_services';
import Preview from './__Preview';

export default {
  name: 'receipt-in',
  components: {
    Preview
  },
  props: {},
  data() {
    return {
      countChecked: 0,
      listQuery: {
        page: 1,
        limit: 30,
        total: 0,
        from: 0,
        to: 0
      },
      daterange: {},
      lastIndexCustomerSelected: 0,
      info: {},
      receiptSelecteds: [],
      tableData: [],
      fields: [
        {
          variant: 'primary',
          key: 'id',
          class: 'checkbox'
        },
        {
          key: 'code',
          label: 'Mã phiếu',
          sortable: true
        },
        {
          tdClass: 'text-center',
          key: 'userCreate',
          label: 'Người tạo',
          sortable: true
        },
        {
          tdClass: 'text-left',
          key: 'customer',
          label: 'Người Đặt hàng',
          sortable: true
        },
        // {
        //   tdClass: "text-center",
        //   key: "userVerify",
        //   label: "Người duyệt hồ sơ",
        //   sortable: true
        // },
        {
          tdClass: 'text-center',
          key: 'dateCreated',
          sortable: true,
          label: 'Ngày tạo'
        },
        {
          tdClass: 'text-center',
          key: 'dateUpdated',
          sortable: true,
          label: 'Lần cuối sửa đổi'
        }
      ]
    };
  },
  mounted() {},
  methods: {
    fetchData() {
      this.pending = true;
      // this.listQuery.from = this.$date(this.daterange.from, "YYYY/MM/DD");
      // this.listQuery.to = this.$date(this.daterange.to, "YYYY/MM/DD");
      this.listQuery.from = this.daterange.from;
      this.listQuery.to = this.daterange.to;
      this.$refs.breceipt.block();
      receiptService
        .findAllIn(this.listQuery)
        .then(res => {
          this.$refs.breceipt.unBlock();
          this.tableData = res.data.data;
          this.listQuery.total = res.data.total;
          this.$refs['soft-table'].selectRow(this.lastIndexCustomerSelected);
        })
        .finally(() => {
          this.pending = false;
        });
    },
    pagChange(page) {
      this.listQuery.page = page;
      this.fetchData();
    },
    handleSearch(keyword) {
      this.listQuery.search = keyword;
      this.fetchData();
    },
    tbRowClicked(item, index) {
      this.info = item;
      this.lastIndexCustomerSelected = index;
    },
    tbHandleContextMenuItemClick(a) {
      console.log('context menu', a);
    },
    handleUpdate() {},
    handleCreate() {},
    handleCopy() {},
    handleHelp() {
      alert('help');
    },
    handleDelete() {
      if (this.countChecked == 0) return;
    },
    tbSetRowSelected(items) {
      this.receiptSelecteds = items;
      this.countChecked = items.length;
    },
    printReceipt(item) {
      this.$refs.preview.visible = true;
      let productReceipts = [];
      item.ReceiptBillDetails.forEach(element => {
        productReceipts.push({
          id: element.id,
          note: element.note,
          quantity: element.quantity,
          total: element.total,
          color: element.manufacture.color,
          product: element.manufacture.product,
          productCustom: element.manufacture.productCustom,
          reason: element.manufacture.reason,
          reasonId: element.manufacture.reasonId,
          productSpecify: element.manufacture.productSpecify,
          position: element.position,
          order: element.order,
          unit: element.unit,
          length: element.length,
          colorText: element.colorText,
          colorCode1: element.colorCode1,
          colorCode2: element.colorCode2
        });
      });
      this.$refs.preview.setData(item, productReceipts);
    },
    printReceiptMuti() {
      let mutiRecepts = [];
      this.receiptSelecteds.forEach(item => {
        let productReceipts = [];
        item.ReceiptBillDetails.forEach(element => {
          productReceipts.push({
            id: element.id,
            note: element.note,
            quantity: element.quantity,
            total: element.total,
            color: element.manufacture.color,
            product: element.manufacture.product,
            productCustom: element.manufacture.productCustom,
            reason: element.manufacture.reason,
            reasonId: element.manufacture.reasonId,
            productSpecify: element.manufacture.productSpecify,
            position: element.position,
            order: element.order,
            unit: element.unit,
            length: element.length,
            colorText: element.colorText,
            colorCode: element.colorCode,
            colorCode1: element.colorCode1,
            colorCode2: element.colorCode2
          });
        });

        productReceipts.sort((a, b) => {
          if (a.product.name < b.product.name) {
            return -1;
          }
          if (a.product.name > b.product.name) {
            return 1;
          } else {
            if (Number(a.productSpecify.name) > Number(b.productSpecify.name)) {
              return 1;
            }
            if (Number(a.productSpecify.name) < Number(b.productSpecify.name)) {
              return -1;
            }
            return 0;
          }
        });

        for (let i = 0; i < productReceipts.length; i++) {
          let item = productReceipts[i];
          item.rowSpan = this.checkSameRow(productReceipts, i, (a, b) => {
            return a.productSpecify.name == b.productSpecify.name && a.product.code == b.product.code;
          });
        }

        let newMuti = Object.assign({}, item);
        newMuti.productReceipts = productReceipts;
        mutiRecepts.push(newMuti);
      });

      this.$refs.preview.visible = true;

      console.log(mutiRecepts);
      this.$refs.preview.setDataMuti(mutiRecepts);
    },
    checkSameRow(datas, index, compareX, count = 1) {
      let nextIndex = index + 1;
      if (nextIndex >= datas.length) return 1;
      let item = datas[index];
      let nextItem = datas[nextIndex];
      if (compareX(item, nextItem)) {
        count++;
        nextItem.hiden = true;
        return 1 + this.checkSameRow(datas, nextIndex, compareX, count);
      }
      return 1;
    },
    verifyReceipt(item) {
      this.$refs.breceipt.block();
      receiptService
        .verifyIn(item.id)
        .then(res => {
          item.status = true;
          item.userVerify = res.data.userVerify;
          this.$alertify.success(res.message, {
            duration: 4000
          });
        })
        .finally(() => {
          this.$refs.breceipt.unBlock();
        });
    }
  },
  watch: {
    daterange: function() {
      this.fetchData();
    }
  }
};
</script>
<style lang="scss"></style>
